import React, {Component} from 'react';
import { connect } from "react-redux";
import $ from 'jquery';
import '../css/validations.css'
import AreYouAgreeModal from './AreYouAgreeModal';
import { ApiClient } from "../libs/apiClient";
import PartnerCreateModal from './PartnerCreateModal';
let apiClient = ApiClient.getInstance();

function getBankCode(bank) {
    switch (bank.toUpperCase()) {
        case '0012': //BBVA BANCOMER
            return '012'; //BBVA BANCOMER SA
        case '2706': //SANTANDER
            return '014'; //SANTANDER
        case '0021': //HSBC
            return '021'; //HSBC MEXICO SA
        case '0030': //BANCO DEL BAJIO
            return '030'; //BANCO DEL BAJIO
        case '0042': //MIFEL
            return '042'; //BANCO MIFEL
        case '0044': //SCOTIABANK INVERLAT
            return '044'; //SCOTIABANK
        case '1011': //BANREGIO
            return '058'; //BANREGIO
        case '0059': //INVEX
            return '059'; //BANCO INVEX
        case '0060': //BANSI
            return '060'; //BANSI
        case '0062': //AFIRME
            return '062'; //BANCA AFIRME
        case '0072': //BANORTE
            return '072'; //BANORTE/IXE
        case '0005': //BANK OF AMERICA
            return '106'; //BANK OF AMERICA
        case '0113':	//VE POR MAS
            return '113'; //BANCO VE POR MAS
        case '1010':	//BANCO AZTECA
            return '127'; //BCA AZTECA
        // BANCOS NO REGISTRADOS EN SAP DE EMPRESA (ATN)
        // case '0102':
        //     return '102'; //ACCENDO BANCO
        // case '0108':
        //     return '108'; //MUFG
        // case '0110':	
        //     return '110'; //J.P. MORGAN
        // case '0112':	
        //     return '112'; //BANCO MONEX
        // case '0133':	
        //     return '133'; //BANCO ACTINVER
        // case '0136':	
        //     return '136'; //INTERCAM BANCO
        // case '0143':	
        //     return '143'; //CIBANCO
        // case '0145':	
        //     return '145'; //BANCO BASE
        // case '0156':	
        //     return '156'; //SABADELL
        // case '0158':	
        //     return '158'; //MIZUHO BANK
        default:
            return '000';
    }
}

class CitibanamexTransactionsModal extends Component {
    constructor (props) {
        super(props);
        this.state = {
            partners: [],
            totalPage: 0,
            currentDocument: {},
            indexPurchaseRequest: -1,
            validations: {
                AccountNum: 0, // -1: Datos incompletos. 1: Cuenta de Cheques. 2: Tarjeta de Débito. 3: Cuenta CLABE. 4: Num. Celular
                Address: 0, // -1: Datos incompletos.
                RFC: 0, // -1: Datos incompletos. -2: Formato incorrecto
                Email: 0, // -1: Datos incompletos. -2: Formato incorrecto
            },
        };
    }
    
    closeModal = () => {
        $("#CitibanamexTransactionsModal").modal("hide");
    }

    changeField = async (index, value, field, validation = undefined) => {
        const { docs, refreshDocuments, notificationReducer: { showAlert } } = this.props;
        let auxDocs = docs.slice();
        let document = auxDocs[index];
        if (validation) {
            return showAlert({ type: 'warning', message: 'Hay una validación'}, 5000); 
        }
        if (field === 'CardCode') {
            // Vaciar campos del socio de negocio
            document.CardName = '';
            document.Address = '';
            document.Address1 = '';
            document.Email = '';
            document.bancos = [];
            document.availableBank = [];
            document.AccountNum = '';
            document.BankCode = '000';
            document.validations= {
                AccountNum: -1,
                Address: -1,
                RFC: 0,
                Email: -1
            };
        }
        document[field] = value;
        await refreshDocuments(auxDocs);
    }
    
    changeTransactionCode = async (index, value) => {
        const { docs, refreshDocuments } = this.props

        let auxDocs = docs.slice();
        let document = auxDocs[index];
        document.TransactionCode = value;
        document.validations.AccountNum = -1;

        if (document.TransactionCode === '072') { // Formatos validos para Trans. Entre Cuentas
            if (document.AccountNum.length === 10) { document.validations.AccountNum = 1; } 
            else if (document.AccountNum.length === 16) { document.validations.AccountNum = 2; }
            else if (document.AccountNum.length === 18) { document.validations.AccountNum = 3; }
            else if (document.AccountNum.length === 11) { document.validations.AccountNum = 4; }
        } else if (document.TransactionCode === '001') { // Formatos validos para Trans. Interbancarias
            if (document.AccountNum.length === 10) { document.validations.AccountNum = 1; }
            else if (document.AccountNum.length === 16) { document.validations.AccountNum = 2; }
            else if (document.AccountNum.length === 18) { document.validations.AccountNum = 3; }
        } else { document.validations.AccountNum = 0; } // No aplica para otros tipos de Transacción

        await refreshDocuments(auxDocs);
    }

    changeAccountNumAux = async (index, value) =>{
        const { docs, refreshDocuments } = this.props
        const auxDocs = docs.slice()
        let document = auxDocs[index];
        const bank = document.bancos.find(clientBnk => {return clientBnk.Account === value})
        document.AccountNum = bank.Account
        document.BankCode = bank.BankCode
        document.validations.AccountNum = -1;
        if(document.BankCode === '000' && document.AccountNum.length > 0 && !isNaN(Number(document.AccountNum))){//trasnf entre cuentas citi
            document.TransactionCode = '072'
            if (document.AccountNum.length === 10) {
                document.AccountNumType = '07';
                document.validations.AccountNum = 1;
            }
            else if (document.AccountNum.length === 16) {
                document.AccountNumType = '03';
                document.validations.AccountNum = 2;
            }
            else if (document.AccountNum.length === 18) {
                document.AccountNumType = '05';
                document.validations.AccountNum = 3;
            }
            else if (document.AccountNum.length === 11) {
                document.AccountNumType = '01';
                document.validations.AccountNum = 4;
            }
        }
        if(document.BankCode !== '000' && document.AccountNum.length === 18 && !isNaN(Number(document.AccountNum)) ){//transf otros bancos
            document.validations.AccountNum = 3
            document.TransactionCode = '001'
        }
        await refreshDocuments(auxDocs);
    }

    changeAccountNum = async (index, value) => {
        const { docs, refreshDocuments, notificationReducer: { showAlert } } = this.props
        const regex = /^\d+$/;
        const maxLength = 20;

        let auxDocs = docs.slice();
        let document = auxDocs[index];

        if (regex.test(value) && value.length <= maxLength) {
            document.AccountNum = value;
            document.validations.AccountNum = -1;
            if (document.TransactionCode === '072') { // Formatos validos para Trans. Entre Cuentas
                if (document.AccountNum.length === 10) {
                    document.AccountNumType = '07';
                    document.validations.AccountNum = 1;
                }
                else if (document.AccountNum.length === 16) {
                    document.AccountNumType = '03';
                    document.validations.AccountNum = 2;
                }
                else if (document.AccountNum.length === 18) {
                    document.AccountNumType = '05';
                    document.validations.AccountNum = 3;
                }
                else if (document.AccountNum.length === 11) {
                    document.AccountNumType = '01';
                    document.validations.AccountNum = 4;
                }
            } else if (document.TransactionCode === '001') { // Formatos validos para Trans. Interbancarias
                if (document.AccountNum.length === 10) {
                    document.AccountNumType = '07';
                    document.validations.AccountNum = 1;
                }
                else if (document.AccountNum.length === 16) {
                    document.AccountNumType = '03';
                    document.validations.AccountNum = 2;
                }
                else if (document.AccountNum.length === 18) {
                    document.AccountNumType = '05';
                    document.validations.AccountNum = 3;
                }
            } else { document.validations.AccountNum = 0; } // No aplica para otros tipos de Transacción
            
            await refreshDocuments(auxDocs);
        } else if (value.length === 0) {
            document.AccountNum = '';
            document.AccountNumType = '';
            document.validations.AccountNum = -1;
            if (document.TransactionCode !== '072' && document.TransactionCode !== '001')  { document.validations.AccountNum = 0; } // No aplica para otros tipos de Transacción

            await refreshDocuments(auxDocs);
        } else {
            showAlert({ type: 'warning', message: 'Ingrese un número de cuenta valido, sin espacios ni guiones'}, 5000); 
        }
    }

    changeAddress = async (index, value, AddressType) => {
        const { docs, refreshDocuments, notificationReducer: { showAlert } } = this.props
        const regex = /[!"#$%()?=¡¨*\[\];:_¿´+{.\}\-\<>°|¬\\~`^Ññ]/; //CARACTERES NO PERMITIDOS
        const maxLength = 35;

        let auxDocs = docs.slice();
        let document = auxDocs[index];

        if (!regex.test(value)) {
            if (value.length <= maxLength) {
                if (AddressType === 1) {
                    document.validations.Address = 0;
                    if (value.trim().length === 0) { document.validations.Address = -1; }
                    document.Address = value;
                }
                else { document.Address2 = value; }
                await refreshDocuments(auxDocs);                
            }
        } else {
            showAlert({ type: 'warning', message: 'Caracteres especiales no permitidos: !"#$%( )=?¡¨*[ ];:_¿´+{ }.-><°|¬\~`^Ññ'}, 5000); 
        }
    }

    changeEmail = async (index, value, AddressType) => {
        const { docs, refreshDocuments, notificationReducer: { showAlert } } = this.props
        const regex = /[!"#$%&/()=?¡¨*\[\];:'¿´+{\},><°|¬\\~`^ñÑ]/; //CARACTERES NO PERMITIDOS
        const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const space = /[\s]/;
        const maxLength = 50;

        let auxDocs = docs.slice();
        let document = auxDocs[index];

        if (!regex.test(value)) {
            if (!space.test(value)) {
                if (value.length <= maxLength) {
                    document.validations.Email = 0;
                    if (!validEmail.test(value)) { document.validations.Email = -2; }
                    if (value.trim().length === 0) { document.validations.Email = -1; }
                    document.Email = value;
                    await refreshDocuments(auxDocs);                
                }
            } else {
                showAlert({ type: 'info', message: 'Solo se puede indicar una cuenta de correo electrónico'}, 3000); 
            }            
        } else {
            showAlert({ type: 'warning', message: 'Caracteres especiales no permitidos: !"#$%&/()=?¡¨*[];:\'¿´+{},><°|¬\\~`^ñÑ'}, 5000); 
        }
    }

    changeTotal = async (index, field, value) => {
        const { docs, refreshDocuments } = this.props;
        let auxDocs = docs.slice();
        let document = auxDocs[index];

        if (!isNaN(value) || value === '') {
            document[field] = value;
            if (field === 'TotalAmount') { document.VatSum = (Number(value ?? '0') * 0.16).toFixed(2); }
        }
        await refreshDocuments(auxDocs);
    }

    validateTotal = async (index, field, value) => {
        const { docs, refreshDocuments } = this.props;
        let auxDocs = docs.slice();
        let document = auxDocs[index];
        document[field] = Number(value || '0').toFixed(2);
        await refreshDocuments(auxDocs);
    }

    validateAllDocsToSend = async () => {
        const { docs, notificationReducer: { showAlert }, openAgreeModal, typeTransaction } = this.props
        const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let error = false;
        let message = '';
        for (let i = 0; i < docs.length; i++) {
            const currentDocument = docs[i];
            if (typeTransaction === 'SR-SAP') {
                if (!currentDocument.CardName || currentDocument.CardName === '') {
                    message = `Error en el documento ${i + 1}: Ingrese un socio de negocio`;
                    error = true;
                    break;
                }

                if (Number(currentDocument.TotalAmount || '0') <= 0) {
                    message = `Error en el documento ${i + 1}: Ingrese un importe mayor a cero`;
                    error = true;
                    break;
                }
            }
            // Números de cuenta
            if(currentDocument.BankCode === '000' && (currentDocument.AccountNum.length <= 0 || isNaN(Number(currentDocument.AccountNum)))){
                message = `Error en el documento ${currentDocument.DocNum}: Ingrese un número de cuenta válido`;
                error = true;
                break;
            }
            if(currentDocument.BankCode === '000' && currentDocument.AccountNum.length > 0 && !isNaN(Number(currentDocument.AccountNum))){
                if(currentDocument.AccountNum.length !== 10 && currentDocument.AccountNum.length !== 16 && currentDocument.AccountNum.length !== 18 && currentDocument.AccountNum.length !== 11){
                    message = `Error en el documento ${currentDocument.DocNum}: Ingrese un número de cuenta válido`;
                    error = true;
                    break;
                }
                
            }
            if(currentDocument.BankCode !== '000' && (currentDocument.AccountNum.length !== 18 || isNaN(Number(currentDocument.AccountNum))) ){
                message = `Error en el documento ${currentDocument.DocNum}: La longitud debe ser de 18 dígitos`;
                error = true;
                break;
            }
            // if (currentDocument.TransactionCode === '072' && (currentDocument.AccountNum.length !== 10 && currentDocument.AccountNum.length !== 11 && currentDocument.AccountNum.length !== 16 && currentDocument.AccountNum.length !== 18)) {
            //     message = `Error en el documento ${currentDocument.DocNum}: Ingrese un número de cuenta valido para Trans. entre Cuentas`;
            //     error = true;
            //     break;
            // }
            // if (currentDocument.TransactionCode === '001' && (currentDocument.AccountNum.length !== 10 && currentDocument.AccountNum.length !== 16 && currentDocument.AccountNum.length !== 18)) {
            //     message = `Error en el documento ${currentDocument.DocNum}: Ingrese un número de cuenta valido para Trans. Interbancaria`;
            //     error = true;
            //     break;
            // }
            

            // Dirección 1
            if (currentDocument.Address.trim().length === 0) {
                message = `Error en el documento ${currentDocument.DocNum}: Ingrese una dirección valida`;
                error = true;
                break;
            }
            
            // Notificación por correo
            if (currentDocument.Notify !== 'NONE' && !validEmail.test(currentDocument.Email)) {
                message = `Error en el documento ${currentDocument.DocNum}: Ingrese una dirección de correo valida`;
                error = true;
                break;
            }
        }
        if (error) { return showAlert({ type: 'error', message }, 5000); }
        openAgreeModal();
    }

    deleteDocument = async (index) => {
        const { docs, refreshDocuments } = this.props;
        let auxDocs = docs.slice();
        auxDocs.splice(index, 1);
        await refreshDocuments(auxDocs);
        if (auxDocs.length === 0) { this.closeModal() }
    }

    openPartner = async (index = null, CardCode = null) => {
        const { docs, enableSpinner, notificationReducer: { showAlert } } = this.props;
        if (!CardCode || CardCode === '') { return; }

        enableSpinner(true);
        let getPartnerResponse = await apiClient.getPartnersCitibanamex(CardCode);
        enableSpinner(false);

        if (getPartnerResponse.status === 0) {
            if (!Array.isArray(getPartnerResponse.data.results)) {
                showAlert({ type: 'info', message: getPartnerResponse.message });
                return;
            }
            if (getPartnerResponse.data.results.length === 0) {
                showAlert({ type: 'info', message: 'No hay Información por mostrar' });
                return;
            }
        }

        if (getPartnerResponse.data.length === 1) {
            if (getPartnerResponse.data[0].validFor === 'N') {
                showAlert({ type: 'error', message: 'El socio de negocio se encuentra inactivo' });
                this.changeField(index, '', 'CardName');
                return;
            }
            await this.selectPartner(getPartnerResponse.data[0], index);
        } else {
            await this.setState({
                partners: getPartnerResponse.data,
                pageTotal: 10,
                currentDocument: docs[index],
                indexPurchaseRequest: index,
            });
            $('#partnerCreate').modal('show');
        }
    }

    selectPartner = async (businessPartner, index) => {
        const { docs, refreshDocuments, notificationReducer: { showAlert } } = this.props;
        let auxDocs = docs.slice();
        let document = auxDocs[index];

        const regexCardName = /[!"#$%\/()=?¡¨*[\];:_¿´+{},.-><°|¬\\~`^Ññ]/g; //CARACTERES NO PERMITIDOS
        const regexAddress = /[!"#$%()=?¡¨*[\];:_¿´+{}.-><°|¬\\~`^Ññ]/g; //CARACTERES NO PERMITIDOS
        const regexEmail = /[!"#$%&/()=?¡¨*\[\];:'¿´+{\},><°|¬\\~`^ñÑ]/; //CARACTERES NO PERMITIDOS
        const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Formato de correo
        const space = /[\s]/; // Más de un correo
        const maxLengthCardName = 80;
        const maxLengthAddress = 35;
        const maxLengthEmail = 50;
    

        document.CardCode = businessPartner.CardCode;

        // Validar formato de Nombre
        document.CardName = businessPartner.CardName.replace(regexCardName, '');
        if (document.CardName.length > maxLengthCardName) { document.CardName = document.CardName.substring(0, maxLengthCardName); }
        else { document.CardName = document.CardName.padEnd(document.CardName.length + (maxLengthCardName - document.CardName.length)); }

        // Validar formato de Dirección
        document.validations.Address = 0;
        document.Address = businessPartner.Address.replace(regexAddress, '');
        document.Address1 = businessPartner.Address1.replace(regexAddress, '');
        if (document.Address.length > maxLengthAddress) { document.Address = document.Address.substring(0, maxLengthAddress); }
        if (document.Address1.length > maxLengthAddress) { document.Address1 = document.Address1.substring(0, maxLengthAddress); }
        if (!document.Address || document.Address === '') { document.validations.Address = -1; }

        // Validar información de correo
        document.validations.Email = 0;
        document.Email = businessPartner.Email;
        if (!!document.Email && document.Email !== '') {
            if (document.Email.length > maxLengthEmail) { document.Email = document.Email.substring(0, maxLengthEmail); document.validations.Email = -1; }
            if (regexEmail.test(businessPartner.Email) || !validEmail.test(businessPartner.Email) || space.test(businessPartner.Email)) { document.validations.Email = -2; }
        }
        else { document.validations.Email = -1; }

        // Dar formato a la información de los bancos
        let auxBank = businessPartner?.AvailableBank?.split('|') ?? [];
        const bancos = []
        for (let bkIdx = 0; bkIdx < auxBank.length; bkIdx++) {
            const currBk = auxBank[bkIdx];
            const auxDataBk = currBk?.split('~') ?? []
            if(auxDataBk.length > 0 ){
                const auxBk = {
                    Account : auxDataBk[0] ?? '',
                    AcctName: auxDataBk[1] ?? '',
                    AbsEntry: auxDataBk[2] ?? '',
                    SwiftNum: auxDataBk[3] ?? '',
                    BankCode: getBankCode(auxDataBk[4] ?? '') ?? '',
                }
                bancos.push(auxBk)
            }
        }
        document.bancos = bancos

        const auxAvailableBank = [
            {key:"000",value:'Transf. entre Cuentas y Cheques de Gerencia'},
            {key:"002",value:'Orden de Pago Tradicional'},
        ]
        const auxBancos = [
            {key:"012",value:'BBVA BANCOMER'},
            {key:"014",value:'SANTANDER'},
            {key:"021",value:'HSBC'},
            {key:"030",value:'BANCO DEL BAJIO'},
            {key:"042",value:'MIFEL'},
            {key:"044",value:'SCOTIABANK INVERLAT'},
            {key:"058",value:'BANREGIO'},
            {key:"059",value:'INVEX'},
            {key:"060",value:'BANSI'},
            {key:"062",value:'AFIRME'},
            {key:"072",value:'BANORTE'},
            {key:"106",value:'BANK OF AMERICA'},
            {key:"113",value:'VE POR MAS'},
            {key:"127",value:'BANCO AZTECA'},
        ]
        const clientBank = auxBancos.filter(f => bancos.some((bank) => bank.BankCode === f.key));
        document.availableBank = auxAvailableBank.concat(clientBank);

        await refreshDocuments(auxDocs);
        if (!!document.bancos && document.bancos.length > 0) { await this.changeAccountNumAux(index, businessPartner.DflAccount); }
    }

    render() {
        const { docs, hideAgreeModal, sendInfo, typeTransaction, addTransaction, currentDocument, indexPurchaseRequest } = this.props;
        const { partners, pageTotal } = this.state;
        return (
            <div
                className="modal fade bd-example-modal-xl modal-open scroll" 
                id="CitibanamexTransactionsModal"
                role="dialog"
                aria-labelledby="exampleModalLabel" 
                aria-hidden="true"
                data-backdrop="static">
                <AreYouAgreeModal
                    mensaje={'Antes de enviar esta información,es crucial verificar que todos los datos sean correctos, ya que ello implicará  transferencias interbancarias. ¿Estás seguro que deseas proceder con el envío de información?'}
                    accept={sendInfo}
                    cancel={hideAgreeModal}
                />
                <PartnerCreateModal
                    data={partners}
                    type={'S'}
                    totalPage={pageTotal}
                    newOrderModel={currentDocument}
                    selectPartner={this.selectPartner}
                    cleanData={() => this.setState({ partners: [] })}
                    refreshPartner={this.refreshPartner}
                    indexPurchaseRequest={indexPurchaseRequest}/>
                <div className="modal-dialog modal-xl modal-open" role="document">
                    <div className="modal-content">
                        <div className="modal-header text-white"
                             style={{backgroundColor: '#343a40', borderRadius: '0'}}>
                            <h4 className="modal-title" id="modal-basic-title ">
                                Datos de transacción
                            </h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.closeModal}>
                                <span className="text-white" aria-hidden="true">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="contanier">
                                <div className="row justify-content-around">
                                    <div className="col-12">
                                        <div>
                                            <table className="table table-scroll response" style={{marginBottom: 0}}>
                                                <div
                                                    className="w-100 tab-pane fade show active "
                                                    id="dataContenido"
                                                    aria-labelledby="nav-home-tab-Contenido"
                                                    style={{maxHeight: 490}}>
                                                    <table
                                                        id="dataTableDocuments"
                                                        className="display"
                                                        style={{width: '100%', marginBottom: 40, marginRight: -2000}}>
                                                        <thead className="table-header-yellow">
                                                            <tr style={{ backgroundColor: '#d2ab24', textAlign: "center" }}>
                                                                <td> Num. Doc </td>
                                                                <td> Proveedor </td>
                                                                <td> Beneficiario </td>
                                                                <td> Tipo de transacción </td>
                                                                <td> Banco </td>
                                                                {/* <td> Tipo de cuenta </td> */}
                                                                <td> Num. Cuenta </td>
                                                                <td> Importe </td>
                                                                <td> Concepto </td>
                                                                <td> Comprobante Fiscal </td>
                                                                <td> Impuestos </td>
                                                                <td> Dirección 1</td>
                                                                <td> Dirección 2(opcional) </td>
                                                                <td> Prioritario </td>
                                                                <td> Confidencial </td>
                                                                <td> Acreditación </td>
                                                                <td> Notificación </td>
                                                                <td> Correo </td>
                                                                <th className='sticky-columns' style={{ backgroundColor: '#d2ab24' }}> Acciones </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                        {docs && docs.length > 0 && docs.map((document, index) => {
                                                            return (
                                                            <tr key={index} style={{ textAlign: "center" }} className={`align-middle  ${document.validations.DocEntry === -1 ? 'invalidFile' : ''}`}>
                                                                <th>{document.DocNum === -1 ? 'N/A' : document.DocNum}</th>
                                                                <td style={{ minWidth: 200 }}>
                                                                    {typeTransaction === 'SAP' ?
                                                                        <>{document.CardCode}</>
                                                                    :
                                                                        <div className="input-group mb-3">
                                                                            <input type="text" className="form-control"
                                                                                id="txtPartner"
                                                                                onKeyPress={(ev) => { if (ev.key === 'Enter') { this.openPartner(index, document.CardCode); }}}
                                                                                onChange={(event) => this.changeField(index, event.target.value, 'CardCode')}
                                                                                value={document.CardCode}/>
                                                                            <button
                                                                                type="button"
                                                                                className="input-group-text"
                                                                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                                onClick={() => this.openPartner(index, document.CardCode)}>
                                                                                <i className="fas fa-user fa-lg" />
                                                                            </button>
                                                                        </div>
                                                                    }
                                                                </td>
                                                                <td style={{ minWidth: 200 }}>
                                                                    <input
                                                                        disabled
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={document.CardName}/>
                                                                </td>
                                                                <td style={{ minWidth: 200 }}>
                                                                    <select className="form-control" value={document.TransactionCode} onChange={(event) => this.changeTransactionCode(index, event.target.value)}>
                                                                        <option value="001">Transf. Interbancaria</option>
                                                                        <option value="072">Transf. entre Cuentas</option>
                                                                        <option value="073">Cheques de Gerencia</option>
                                                                        <option value="277">Orden de Pago Tradicional</option>
                                                                        <option value="002">Pago de Salario</option>
                                                                        <option value="003">Pago de Pensión</option>
                                                                    </select>
                                                                </td>
                                                                <td style={{ minWidth: 200 }}>
                                                                    <select 
                                                                    disabled={true} 
                                                                    className="form-control" 
                                                                    value={document.BankCode} 
                                                                    // onChange={(event) => this.changeField(index, event.target.value, 'BankCode')}
                                                                    >
                                                                        {!!document.availableBank && document.availableBank.map((bankOption,idx)=>{
                                                                            return <option key={bankOption.key} value={bankOption.key}>{bankOption.value}</option>
                                                                            })
                                                                        }
                                                                    </select>
                                                                </td>
                                                                {/* <td>{document.AccountType}</td> */}
                                                                <td style={{ minWidth: 350 }} className='text-left'>
                                                                    <div className="input-group">
                                                                        {/* <input
                                                                            onChange={(event) => this.changeAccountNum(index, event.target.value)}
                                                                            className={`form-control ${document.validations.AccountNum === -1 ? 'invalidInput' : ''}`}
                                                                            type="text"
                                                                            value={document.AccountNum}/> */}
                                                                        <select
                                                                        className={`form-control ${document.validations.AccountNum === -1 ? 'invalidInput' : ''}`}
                                                                        value={document.AccountNum}
                                                                        onChange={(event) => this.changeAccountNumAux(index, event.target.value)}
                                                                        >
                                                                            {!!document.bancos && document.bancos.map((bank,index)=>{
                                                                                return <option key={bank.Account + index} value={bank.Account}>{bank?.SwiftNum ?? ''} - {bank?.Account ?? ''}</option>
                                                                            })}
                                                                        </select>
                                                                        <button type="button"
                                                                            className="input-group-text"
                                                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                                                            onClick={() => this.GuideUser(`AccountNum-${document.TransactionCode}`)}>
                                                                            <i className="fa fa-info-circle" />
                                                                        </button>
                                                                    </div>
                                                                    {document.validations.AccountNum === -1 && <label className='messageError'>Datos incompletos</label>}
                                                                    {document.validations.AccountNum === 1 && <label className='messageSuccess'>Numero de celular</label>}
                                                                    {document.validations.AccountNum === 2 && <label className='messageSuccess'>Tarjeta de Débito</label>}
                                                                    {document.validations.AccountNum === 3 && <label className='messageSuccess'>Cuenta CLABE</label>}
                                                                    {document.validations.AccountNum === 4 && <label className='messageSuccess'>Cuenta de Cheques</label>}
                                                                </td>
                                                                <td style={{ minWidth: 150 }}>
                                                                    {typeTransaction === 'SAP' ?
                                                                        <>{document.TotalAmount}</>
                                                                    :
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            onChange={(event) => this.changeTotal(index, 'TotalAmount', event.target.value)}
                                                                            onBlur={() => this.validateTotal(index, 'TotalAmount', document.TotalAmount)}
                                                                            value={document.TotalAmount}/>
                                                                    }
                                                                </td>
                                                                <td style={{ minWidth: 200 }}>
                                                                    <input
                                                                        onChange={(event) => this.changeField(index, event.target.value, 'ConceptPayment')}
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={document.ConceptPayment}/>
                                                                </td>
                                                                <td>
                                                                    <select className="form-control" value={document.DocumentType} onChange={(event) => this.changeField(index, event.target.value, 'DocumentType')}>
                                                                        <option value="05">Sin Comprobante</option>
                                                                        <option value="06">Con Comprobante</option>
                                                                        <option value="07">Pago de Nómina Citibanamex</option>
                                                                    </select>
                                                                </td>
                                                                <td style={{ minWidth: 150 }}>
                                                                    {typeTransaction === 'SAP' ?
                                                                        <>{document.VatSum}</>
                                                                    :
                                                                        <input
                                                                            className="form-control"
                                                                            type="text"
                                                                            onChange={(event) => this.changeTotal(index, 'VatSum', event.target.value)}
                                                                            onBlur={() => this.validateTotal(index, 'VatSum', document.VatSum)}
                                                                            value={document.VatSum}/>
                                                                    }
                                                                </td>
                                                                <td style={{ minWidth: 250 }} className='text-left'>
                                                                    <input
                                                                        onChange={(event) => this.changeAddress(index, event.target.value, 1)}
                                                                        className={`form-control ${document.validations.Address === -1 ? 'invalidInput' : ''}`}
                                                                        type="text"
                                                                        value={document.Address}/>
                                                                    {document.validations.Address === -1 && <label className='messageError'>Datos incompletos</label>}
                                                                </td>
                                                                <td style={{ minWidth: 200 }}>
                                                                    <input
                                                                        onChange={(event) => this.changeAddress(index, event.target.value, 2)}
                                                                        className="form-control"
                                                                        type="text"
                                                                        value={document.Address2}/>
                                                                </td>
                                                                <td>
                                                                    <select className="form-control" value={document.Priority} onChange={(event) => this.changeField(index, event.target.value, 'Priority')}>
                                                                        <option value="N">No</option>
                                                                        <option value="Y">Si</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select className="form-control" value={document.Confidential} onChange={(event) => this.changeField(index, event.target.value, 'Confidential')}>
                                                                        <option value="N">No</option>
                                                                        <option value="Y">Si</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select className="form-control" value={document.AccreditationDate} onChange={(event) => this.changeField(index, event.target.value, 'AccreditationDate')}>
                                                                        <option value="00">24Hrs (CECOBAN)</option>
                                                                        <option value="01">Mismo Día (SPEI)</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <select className="form-control" value={document.Notify} onChange={(event) => this.changeField(index, event.target.value, 'Notify')}>
                                                                        <option value="NONE">Ninguna</option>
                                                                        <option value="E-Mail">Por correo</option>
                                                                    </select>
                                                                </td>
                                                                <td style={{ minWidth: 200 }} className='text-left'>
                                                                    <input
                                                                        disabled={document.Notify === 'NONE'}
                                                                        onChange={(event) => this.changeEmail(index, event.target.value)}
                                                                        className={`form-control ${document.Notify !== 'NONE' && document.validations.Email !== 0 ? 'invalidInput' : ''}`}
                                                                        type="text"
                                                                        value={document.Email}/>
                                                                    {document.Notify !== 'NONE' && document.validations.Email === -1 && <label className='messageError'>Datos incompletos</label>}
                                                                    {document.Notify !== 'NONE' && document.validations.Email === -2 && <label className='messageError'>Dirección de corre invalida</label>}
                                                                </td>
                                                                <td className='sticky-columns' style={{ backgroundColor: '#FFF', textAlign: 'center', width: 300 }}>
                                                                    <div style={{ width: 90 }}>
                                                                        <button
                                                                            type="button"
                                                                            style={{ backgroundColor: 'transparent', padding: 5, color: '#c42222', paddingTop: 2, paddingBottom: 2, }}
                                                                            className="btn"
                                                                            onClick={() => this.deleteDocument(index)}
                                                                            >
                                                                            <i className="fas fa-trash-alt" aria-hidden="true" size="10" />
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            );
                                                        })}
                                                        
                                                        {typeTransaction === 'SR-SAP' &&
                                                        <tr>
                                                            <td className="sticky-column"
                                                                style={{ backgroundColor: '#FFF', textAlign: 'center' }}>
                                                                <div>
                                                                    <button
                                                                        type="button"
                                                                        style={{
                                                                            backgroundColor: 'transparent',
                                                                            padding: 5,
                                                                            color: 'green',
                                                                        }}
                                                                        className="btn"
                                                                        onClick={addTransaction}>
                                                                        <i className="fa fa-plus-circle" aria-hidden="true" size="10" />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        }
                                                        </tbody>
                                                    </table>
                                                </div>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn botonCorrect"
                                onClick={this.validateAllDocsToSend}>
                                Enviar
                            </button>
                            <button
                                type="button"
                                className="btn botonCerrar text-white"
                                onClick={this.closeModal}>
                                Cerrar
                            </button>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    }

    GuideUser = (theme) => {
        const { notificationReducer: { showAlert } } = this.props

        switch (theme) {
            case 'AccountNum-072':
                showAlert({ type: 'info', message: 'Transferencias entre Cuentas\n11 dígitos (Cuenta de Cheques)\n16 dígitos (Tarjeta de Débito)\n18 dígitos (Cuenta CLABE)\n10 dígitos (Num. Celular)', timeOut: 10000 });
                break;
            case 'AccountNum-001':
                showAlert({ type: 'info', message: 'Transferencias Interbancarias\n16 dígitos (Tarjeta de Débito)\n18 dígitos (Cuenta CLABE)\n10 dígitos (Num. Celular)', timeOut: 10000 });
                break;
            case 'AccountNum-073':
                showAlert({ type: 'info', message: 'Cheque de Gerencia y Orden de Pago\nNo usar (Dejar en blanco)', timeOut: 10000 });
                break;
            case 'AccountNum-277':
                showAlert({ type: 'info', message: 'Cheque de Gerencia y Orden de Pago\nNo usar (Dejar en blanco)', timeOut: 10000 });
                break;
            default:
                break;
        }

    }
}
const mapStateToProps = store => {
    return {notificationReducer: store.NotificationReducer};
};

export default connect(
    mapStateToProps
)(CitibanamexTransactionsModal);